import { useEffect } from "react";
import { Typography } from "../../../../../core/components/molecules/Typography";
import { useGetHubWeekTime } from "../../../hooks/ScheduleHub/useGetHubWeekTime";
import StudyTimeProgressItem from "../StudyTimeProgressItem";
import BrainLoadingWrapper from "../../../../../core/components/molecules/BrainLoading";
import { ScheduleStartInfo } from "../../../utils/scheduleStart";

interface IStudyTimeProgress {
  cronogramaId?: string;
  refreshTrigger?: number;
  startInfo: ScheduleStartInfo;
  isHome?: boolean;
}

const legend = [
  {
    color: 'bg-feedback-color-error-pure',
    label: 'Atrasado',
  },
  {
    color: 'bg-brand-color-primary-pure',
    label: 'Em dia',
  },
  {
    color: 'bg-feedback-color-success-pure',
    label: 'Adiantado',
  },
];

const StudyTimeProgress: React.FC<IStudyTimeProgress> = ({
  cronogramaId,
  refreshTrigger,
  startInfo,
  isHome,
}) => {
  const { mutate, isPending, isError, data } = useGetHubWeekTime();

  useEffect(() => {
    if (cronogramaId) {
      mutate(cronogramaId);
    }
  }, [cronogramaId, refreshTrigger]);

  const showContent = () => {
    if (isPending || !cronogramaId) {
      return (
        <div className='flex h-full flex-col items-center justify-center'>
          <BrainLoadingWrapper size='md' />
        </div>
      );
    }

    if (isError || !data) {
      return (
        <div className='flex flex-col  gap-4 py-4'>
          <Typography
            type='p'
            className='text-xs font-normal italic text-mono-color-dark'
          >
            O gráfico ficará disponível após suas primeiras interações com seus
            conteúdos e atividades.
          </Typography>
        </div>
      );
    }

    const weekDays = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'];
    const normalizedData = weekDays.map((day) => {
      const dayData = data?.find((item) => item.day === day);
      return dayData || { day, progress: 0, status: 'onTime' as const };
    });

    return (
      <div className='flex flex-col gap-4 h-full'>
        <div className='grid grid-cols-7 gap-4'>
          {normalizedData.map((item) => (
            <StudyTimeProgressItem
              key={item.day}
              day={item.day}
              progress={item.progress}
              status={item.status}
            />
          ))}
        </div>

        <div className='flex w-full flex-row items-center justify-center gap-2 rounded-lg'>
          {legend.map((item, index) => (
            <div
              key={`${index}-legend${item.label}`}
              className='flex flex-row items-center gap-2 '
            >
              <div className={`h-3 w-3 ${item.color}  rounded-pill`} />
              <Typography size='small' className='text-mono-color-dark'>
                {item.label}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div data-tour="study-time-progress" className={`h-[300px] p-5 bg-mono-color-white rounded-lg flex flex-col justify-between gap-3`}>
      <div className="flex flex-row items-center justify-between">
        <Typography type='title' size='h3'>
          Status da Semana
        </Typography>
      </div>
      {showContent()}
    </div>
  );
};

export default StudyTimeProgress;
